import { render, staticRenderFns } from "./addEditJC.vue?vue&type=template&id=297b1b61&scoped=true&"
import script from "./addEditJC.vue?vue&type=script&lang=js&"
export * from "./addEditJC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297b1b61",
  null
  
)

export default component.exports